const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progress: {
    position: 'relative',
    marginTop: '150px',
    marginRight: '400px',
  },
  top: {
    color: '#FE6215 !important',
    animationDuration: '2000ms',
    position: 'absolute',
    left: 0,
  },
  circle: {
    strokeLinecap: 'round',
    color: 'primary',
  },
  logo: {
    position: 'absolute',
    left: 80,
    top: 90,
  },
})

export default styles
